define(
  'app/factories/fix_sidebar_custom_factory',['app/setup', 'app/lib/ismobile', 'app/views/fix_sidebar'],
  function(takhfifan, deviceDetect, fixSidebar) {
    $(function($) {
      var desktopWidth = 980,
          isPhone = window.isMobile && window.isMobile.phone,
          alreadyInit = false;

      init();
      if(!isPhone){
        $(window).on('resize', _.throttle(function(){init();},500));
      }

      function init(){

        if(isPhone){
          $('.tkh-menu-items').addClass("hide");
          $('.tkh-multiple-item').addClass("open");
        }

        $('.tkh-multiple-item').on("click", function() {
          $('.tkh-menu-items').toggleClass( "hide" );
          $('.tkh-multiple-item').toggleClass( "open" );
        });

        if($(window).width() < desktopWidth){return}
        if(alreadyInit){
          takhfifan.eventHub.trigger('sticky:update');
          return;
        }

        //$('.tkh-fix-sidebar-custom').each(function() {
        //  var $this = $(this),
        //      $thisSideBar = $(this).find('.tkh-fix-sidebar-custom__side'),
        //      $thisSideBarInner = $(this).find('.tkh-fix-sidebar-custom__inner');

        //  $this.find('.tkh-fix-sidebar-custom__child').children().each(function(){
        //    $(this).clone().addClass('hide-on-mobile').appendTo($thisSideBarInner);
        //    $(this).addClass('hide-on-desktop');
        //  });

        //  new takhfifan.fixSidebar({
        //    el: $thisSideBar,
        //    containerSelector: '.tkh-fix-sidebar-custom',
        //    innerWrapperSelector: '.tkh-fix-sidebar-custom__inner',
        //    stickyClass: 'side-is-fixed',
        //    topSpacing: 90
        //  });
        //});
        alreadyInit = true;
      }

    });
  });

